import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-right: 3rem;
  margin-top: 1rem;
`;

export const TableHeader = styled.div`
  background-image: linear-gradient(to right, #2a3da3, #206be5);
  color: white;
  font-size: 1.4rem;
  padding: 0.8rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${"" /* min-width: 17rem; */}
  border-radius: "10px";
  overflow: "hidden";
`;

export const TableBodyRow = styled.div`
  height: 2.8rem;
  width: 100%;
  ${"" /* min-width: 17rem; */}
  /* background-color: lightgray; */
  background-color: ${({ backgroundColor }) => backgroundColor || "white"};
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
